module.exports = __webpack_public_path__ + "img/GDD-min.173dcae0.png";